export default __webpack_public_path__ + "static/media/avatar_ali7.7210db9b.mp3";